// extracted by mini-css-extract-plugin
module.exports = {"singleSuper":"SingleSuperTabComponent--singleSuper--WWSk_4_"};